import React from 'react'
import { INavigationRoute } from '../NavigationBar/types'
import {
  NavigationItemButton,
  NavigationItemLink,
  NavigationItemIcon,
  NavigationItemAvatar,
} from './components'

export interface INavigationItemProps {
  route: INavigationRoute
  /**
   * @default false
   */
  isOpen?: boolean
  onClick?: (name: string) => void
}

const NAVIGATION_ITEM_COMPONENTS_BY_KEY = {
  button: NavigationItemButton,
  link: NavigationItemLink,
  icon: NavigationItemIcon,
  avatar: NavigationItemAvatar,
} as const

const getNavigationItemComponent = (route: INavigationRoute) => {
  const { type } = route || {}
  switch (type) {
    case 'icon':
      return NAVIGATION_ITEM_COMPONENTS_BY_KEY.icon
    case 'button':
      return NAVIGATION_ITEM_COMPONENTS_BY_KEY.button
    case 'avatar':
      return NAVIGATION_ITEM_COMPONENTS_BY_KEY.avatar
    case 'link':
    default:
      return NAVIGATION_ITEM_COMPONENTS_BY_KEY.link
  }
}

const NavigationItem = ({ route: routeProp, ...props }: INavigationItemProps) => {
  const Component = getNavigationItemComponent(routeProp)
  return <Component route={routeProp} {...props} />
}

export default NavigationItem
